import React from 'react';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const YourQuestionsAnsweredTextBlock = (): JSX.Element => (
  <HeadingAndSupportingText
    heading={{
      type: 'heading',
      size: 'xl',
      text: 'Your Questions, Answered.',
      fontWeight: 'font-weight-semibold',
      letterSpacing: -1,
      textAlign: 'center',
    }}
    supportingText={{
      type: 'paragraph',
      size: 'xl',
      color: 'text-tertiary',
      text: "With $500M in host results, here's what's working right now.",
      textAlign: 'center',
    }}
  />
);

export default YourQuestionsAnsweredTextBlock;
